import { render, staticRenderFns } from "./FOpinion.vue?vue&type=template&id=6ab135e2&scoped=true&"
import script from "./FOpinion.vue?vue&type=script&lang=js&"
export * from "./FOpinion.vue?vue&type=script&lang=js&"
import style0 from "./FOpinion.vue?vue&type=style&index=0&id=6ab135e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab135e2",
  null
  
)

export default component.exports